import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'
import * as api from '@owl-nest/api-client/next'
import * as models from '@owl-nest/models'

type StretchGoalProps = {
  project: api.Project
  lang: api.Lang
  committed: number
}

export function StretchGoal({ project, lang, committed }: StretchGoalProps) {
  if (project.stages === undefined || !project.goal_raised || models.project.isFinished(project)) {
    return <></>
  }

  const stretchGoal = project.stages.find((stage) => stage.status === api.StretchGoalStatus.ONGOING)

  if (stretchGoal === undefined) {
    return <></>
  }

  const progress = (committed / stretchGoal.goal) * 100

  return (
    <Wrapper>
      <plume.Tag color="blue" icon={<plume.glyphs.fill.Star size={8} />}>
        {t('Next goal')}
      </plume.Tag>
      <Name>{models.i18n.get(stretchGoal.title)}</Name>
      <plume.styles.progressBar.ProgressBar aria-label={t('Goal progression')} $value={progress} />
      <Goal>
        {project.type === api.ProjectType.Presale ? (
          t('%(goal)d presales', { goal: stretchGoal.goal })
        ) : (
          <plume.LocaleMoneyDisplayer amount={stretchGoal.goal} currency={project.currency} localeFormat={lang} />
        )}
      </Goal>
    </Wrapper>
  )
}

const Name = styled(plume.styles.copy.S.semiBold)``

const Goal = styled(plume.styles.copy.S.semiBold)``

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 24px;

  ${plume.Tag} {
    flex: 0 0 auto;
    margin-right: 8px;
  }

  ${Name} {
    flex: 0 0 auto;
  }

  ${plume.styles.progressBar.ProgressBar} {
    flex: 0 0 100%;
    margin: 12px 0;
    border: none;
  }

  ${Goal} {
    flex: 0 0 auto;
    margin-left: auto;
  }
`
